<script lang="ts">
    import {_} from 'svelte-i18n'
    import type {Session} from './types';
    import {
        createAutoUpdatingStore,
        getAssignedActiveConversations,
        getElapsedTime,
        getMaxDate,
        isOfSession
    } from './service/util';
    import {activeConversations, endedConversations, pendingConversations} from './services';
    import {derived, get} from 'svelte/store';
    import type {Readable} from 'svelte/store';
    import type {Conversation} from './types';
    import ConversationName from './ConversationName.svelte';

    export let session: Session;

    const sessionActiveConversation: Readable<Conversation | null> = derived(activeConversations, (_activeConversations: Conversation[]) => {
        const myActiveConversations = getAssignedActiveConversations(session, _activeConversations);
        return myActiveConversations.length === 0 ? null : myActiveConversations[0];
    });

    function getWastingTime() {
        if (get(pendingConversations).length === 0) {
            return null;
        }
        if (get(sessionActiveConversation)) {
            return null;
        }

        // resolve timewasting from-date
        // firstly, by resolving time, when we were without any work lastly
        const myLastConversationEndDate: Date | undefined = get(endedConversations)
            .filter(conversation => isOfSession(conversation, session)) // only conversations of given session
            .map(conversation => conversation.endDate)
            .sort((a, b) => b - a)[0]; // sort desc
        const lastNotChattingDate = myLastConversationEndDate || session.createDate;

        // then resolve time, when started first pending conversation
        const firstPendingConversationCreateDate: Date = get(pendingConversations)
            .map(conversation => conversation.createDate)[0];

        // from-time is max of these two times
        const fromDate = getMaxDate(lastNotChattingDate, firstPendingConversationCreateDate);

        return getElapsedTime(fromDate, new Date());
    }

    const wastingElapsedTime = createAutoUpdatingStore(() => getWastingTime(), 1000);
</script>

{#if $sessionActiveConversation}
	<span>
		<slot />
        {$_('chat.chat')} <ConversationName conversation={$sessionActiveConversation} />
	</span>
{:else if $wastingElapsedTime}
	<span>
		<slot />
        {$_('chat.heDidNotYetStarted')} {$wastingElapsedTime}
	</span>
{/if}
